import * as React from 'react';
import { Avatar } from 'antd';

export default class MerchantTitle extends React.Component<{
  title: string,
  photo: string,
}> {
  render() {
    const { title, photo } = this.props;

    return (
      <div className="company-title">
        <span>
          <Avatar
            src={photo}
            className="img-card-title"
          />
          {title}
        </span>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/merchants/forms/MerchantTitle.tsx